(() => {
  const root = document.querySelector('#ice-home');
  if (!root) return;

  const lockPage = (locked) => document.body.classList.toggle('ice-lock', locked);
  const menu = root.querySelector('[data-ice-menu]');
  const openMenu = root.querySelector('[data-ice-menu-open]');
  const closeMenu = root.querySelector('[data-ice-menu-close]');

  const setMenu = (open) => {
    if (!menu) return;
    menu.hidden = !open;
    menu.classList.toggle('is-open', open);
    openMenu?.setAttribute('aria-expanded', String(open));
    lockPage(open);
    if (open) closeMenu?.focus();
  };

  openMenu?.addEventListener('click', () => setMenu(true));
  closeMenu?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  const filterButtons = [...root.querySelectorAll('[data-ice-filter]')];
  const productCards = [...root.querySelectorAll('[data-ice-product-card]')];
  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.iceFilter;
      filterButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('active', active);
        item.setAttribute('aria-selected', String(active));
      });
      productCards.forEach((card) => {
        card.hidden = filter !== 'All' && card.dataset.category !== filter;
      });
    });
  });

  const modal = root.querySelector('[data-ice-modal]');
  const modalImage = modal?.querySelector('[data-modal-image]');
  const modalCategory = modal?.querySelector('[data-modal-category]');
  const modalTitle = modal?.querySelector('[data-modal-title]');
  const modalDescription = modal?.querySelector('[data-modal-description]');
  const modalMeta = modal?.querySelector('[data-modal-meta]');
  const modalLink = modal?.querySelector('[data-modal-link]');

  const setModal = (open, source) => {
    if (!modal) return;
    if (open && source) {
      modalImage.src = source.dataset.image || '';
      modalImage.alt = source.dataset.title || '';
      modalCategory.textContent = source.dataset.category || '';
      modalTitle.textContent = source.dataset.title || '';
      modalDescription.textContent = source.dataset.description || '';
      modalMeta.textContent = source.dataset.meta || '';
      modalLink.href = source.dataset.link || '/pages/contact-us';
    }
    modal.hidden = !open;
    modal.classList.toggle('is-open', open);
    lockPage(open);
    if (open) modal.querySelector('[data-ice-modal-close]')?.focus();
  };

  root.querySelectorAll('[data-ice-quick-view]').forEach((button) => {
    button.addEventListener('click', () => setModal(true, button));
  });
  modal?.querySelector('[data-ice-modal-close]')?.addEventListener('click', () => setModal(false));
  modal?.addEventListener('mousedown', (event) => {
    if (event.target === modal) setModal(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (modal?.classList.contains('is-open')) setModal(false);
    if (menu?.classList.contains('is-open')) setMenu(false);
  });
})();
